var brand_scrollAmount = 500;
var brandsArray = [];

$(document).on('click', "#brand-carousel-arrow-left", brand_carrousel_left);
$(document).on('click', "#brand-carousel-arrow-right", brand_carrousel_right);

$(document).ready(function(){
  getAllBrands();
});
function getAllBrands(){
  GetMethodFunction('/Home/Brand/Get', null, showAllBrands, null);
}
function brand_carrousel_left(){
  var container = $('#brand-carousel-list');
  container.animate({ scrollLeft: container.scrollLeft() - brand_scrollAmount }, 500);
}
function brand_carrousel_right(){
  var container = $('#brand-carousel-list');
  container.animate({ scrollLeft: container.scrollLeft() + brand_scrollAmount }, 500);
}
function showAllBrands(result){ 
  brandsArray = result.brands;
  let AppendContentCarousel = '';
  let AppendContetList = '';
  $.each(result.brands, function(index, brand){
    //brand carousel
    AppendContentCarousel += '<li class="brand-carousel-list-item my-0 p-0" onclick="location.href=\'/Brand/'+brand.url+'\'">';
      AppendContentCarousel += '<img class="brand-carousel-img" src="'+brand.path+'" alt="'+brand.name+'">';
      AppendContentCarousel += '<p class="brand-carousel-name">'+brand.name+'</p>';
    AppendContentCarousel += '</li>';
    //brand list
    AppendContetList += '<li class="brand-list-item d-flex" value="'+brand.id+'">';
      AppendContetList += '<div class="brand-list-item-img-container row align-content-center">';
        AppendContetList += '<img class="brand-list-item-img" src="'+brand.path+'" alt="'+brand.name+'">';
        AppendContetList += '<h5 class="brand-list-item-name">'+brand.name+'</h5>';
        AppendContetList += '<button class="brand-list-item-btn" onclick="location.href=\'/Brand/'+brand.url+'\'">VER MÁS</button>';
      AppendContetList += '</div>';
      AppendContetList += '<ul class="products-list brand-list-item-products-carousel">';
      AppendContetList += '</ul>';
    AppendContetList += '</li>';
  });  
  $('#brand-carousel-list').empty().append(AppendContentCarousel);
  $('#brand-list').empty().append(AppendContetList);
  $.each(result.brands, function(index, brand){
    getBrandTopProducts(brand.id);
  }); 
}
function getBrandTopProducts(brand_id){
  let data = {
    brand_id: brand_id,
    size: 5
  };
  PostMethodFunction('/Home/Catalogue/Product/GetTopProductsByBrand', data, null, showBrandTopProducts, null);
}
function showBrandTopProducts(result){
  //console.log('showBrandTopProducts => ', result);
  let AppendContent = '';
  //for(var i = 0 ; i < 6 ; i++){
  $.each(result.data.products, function(index, product){
    AppendContent += '<li class="brand-list-item-product products-list-item" onclick="location.href=\'/Product/'+product.url+'\'">';
        if(product.front_images != null && product.front_images.length > 0){
          //get random position of front images
          let randomPosition = Math.floor(Math.random() * product.front_images.length);
          AppendContent += '<div class="product-img" style="background-image: url(\'/'+product.front_images[randomPosition].path+'\')">';
          AppendContent += '</div>';
        }
        AppendContent += '<p class="product-name text-start" title="'+product.name+'">'+product.name+'</p>';
        //brands
        brandsString = '';
        $.each(product.brands, function(index, brand){
          brandsString += brand.name + ', ';
        });
        brandsString = brandsString.substring(0, brandsString.length - 2);
        if(brandsString != ''){
          AppendContent += '<p class="product-brand text-start" title="'+brandsString+'">'+brandsString+'</p>';
        }
        //price
        AppendContent += '<p class="product-price text-start" title="$'+product.price.toLocaleString()+' USD">$'+product.price.toLocaleString()+' USD</p>';
        //normal price
        if(product.normal_price != null && product.normal_price > 0){
          AppendContent += '<p class="product-normal-price text-start">$'+product.normal_price.toLocaleString()+' USD</p>';
        }
        
    AppendContent += '</li>';
  });
  //}
  $('.brand-list-item[value="'+result.data.brand_id+'"] .brand-list-item-products-carousel').empty().append(AppendContent);
}